import React from "react";
import { MessageSquare, Crown, Infinity as InfinityIcon } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

/** Tiny pill that shows AI chat quota — slots into the chat header. */
const ChatUsageBadge = ({ usage, className = "" }) => {
  if (!usage) return null;
  if (usage.unlimited) {
    return (
      <Badge
        variant="outline"
        className={cn("gap-1 border-amber-500/40 text-amber-600 dark:text-amber-400", className)}
        data-testid="chat-usage-badge"
      >
        <Crown className="h-3 w-3" />
        <span>Unlimited</span>
        <InfinityIcon className="h-3 w-3" />
      </Badge>
    );
  }
  const remaining = usage.remaining ?? 0;
  const total = usage.limit ?? 0;
  const danger = remaining === 0;
  const warn = !danger && remaining <= Math.max(1, Math.round(total * 0.2));
  return (
    <Badge
      variant="outline"
      className={cn(
        "gap-1",
        danger
          ? "border-destructive/50 text-destructive"
          : warn
          ? "border-[hsl(var(--warning))]/40 text-[hsl(var(--warning))]"
          : "border-border text-muted-foreground",
        className
      )}
      data-testid="chat-usage-badge"
    >
      <MessageSquare className="h-3 w-3" />
      <span data-testid="chat-usage-count">
        {remaining} / {total} chats left today
      </span>
    </Badge>
  );
};

export default ChatUsageBadge;
